import axios from 'axios'
import type { PersonAdditionalData, SimpleItem } from 'BrokerTsLib/src/dtos'
import type { AresData, User } from 'BrokerTsLib/src/dtos/User'
import type { GenericQueryOptions } from 'BrokerTsLib/src/hooks'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { useMutation, useQuery } from 'react-query'

import { useUrl } from '.'
import { Apis } from '../appSettings/AppSettings'

export const useGetUsers = (
  ouId?: number,
  options?: GenericQueryOptions<User[]>,
) => {
  const url = useUrl(Apis.user)
  return useQuery({
    queryKey: ['useGetAll', ouId],
    queryFn: () => axios.get<User[]>(`${url}/GetUsers`, { params: { ouId } }),
    staleTime: longStaleTime, ...options
  })
}

export const useGetOrganizationUnits = (
  options?: GenericQueryOptions<SimpleItem[]>,
) => {
  const url = useUrl(Apis.user)
  return useQuery({
    queryKey: ['useGetOrganizationUnits'],
    queryFn: () => axios.get<SimpleItem[]>(`${url}/GetOrganizationUnits`),
    staleTime: longStaleTime, ...options
  })
}

export const useGetAres = () => {
  const url = useUrl(Apis.user)

  return useMutation((ic: string) => axios.get<AresData>(`${url}/GetAres?ic=${ic}`).then(x => x.data))
}

export const useGetBirthdate = (
  birthnumber?: string,
  options?: GenericQueryOptions<Date>,
) => {
  const url = useUrl(Apis.user)
  return useQuery({
    queryKey: ['useGetBirthdate', birthnumber],
    queryFn: () =>
      axios.get<Date>(
        `${url}/GetBirthdateFromBirthnumber?birthnumber=${birthnumber}`,
      ),
    staleTime: longStaleTime,
    ...options
  })
}

export const useFindPerson = () => {
  const url = useUrl(Apis.user)
  return useMutation((birthnumber?: string) =>
    axios.post<PersonAdditionalData>(
      `${url}/FindPerson?birthnumber=${birthnumber}`,
    ),
  )
}

export const useGetPossibleCreateContractUsers = (options?: GenericQueryOptions<User[]>) => {
  const url = useUrl(Apis.user)
  return useQuery({
    queryKey: ['useGetPossibleCreateContractUsers'],
    queryFn: () => axios.get<User[]>(`${url}/GetPossibleCreateContractUsers`),
    staleTime: longStaleTime,
    ...options
  })
}
